import { Divider, Text } from "react-native-paper";
import { useDevice } from "../../../useDevice";
import Box from "../../Box";
import Button from "../../Button";
import { FlatCard } from "../../Cards/FlatCard";
import { InsightCallout } from "../../DataCards/InsightCallout";
import FeaturesSection from "../../IAPModal/FeaturesSection";
import ProductIcon from "../../ProductIcon";

export type SessionReportPremiumCardProps = {
	title: string;
	description?: string;
	features: string[];
	imageUrl: string;
	tipText?: string;
	ctaLabel: string;
	onUpgrade: () => void;
};

export type SessionReportPremiumCardContent = Omit<
	SessionReportPremiumCardProps,
	"onUpgrade"
>;

export const SessionReportPremiumCard = ({
	title,
	description,
	features,
	imageUrl,
	tipText,
	ctaLabel,
	onUpgrade,
}: SessionReportPremiumCardProps) => {
	const { isMobile } = useDevice();

	return (
		<FlatCard style={isMobile ? { borderRadius: 0 } : undefined}>
			<Box padding={16} gap={16} alignItems="center">
				<ProductIcon image={imageUrl} size={128} showBorder={false} />
				<Box alignItems="center" width="100%">
					<Text variant="titleMedium" style={{ textAlign: "center" }}>
						{title}
					</Text>
					{description ? (
						<Text variant="bodySmall" style={{ textAlign: "center" }}>
							{description}
						</Text>
					) : null}
				</Box>
			</Box>
			<Divider />
			<Box paddingTop={16} paddingHorizontal={24}>
				<FeaturesSection features={features} />
			</Box>
			<Box padding={16} gap={16}>
				{tipText ? (
					<InsightCallout
						text={tipText}
						variant="flat"
						showTrailingIcon={false}
					/>
				) : null}
				<Button mode="contained" onPress={onUpgrade}>
					{ctaLabel}
				</Button>
			</Box>
		</FlatCard>
	);
};
